import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcYearMonthInputComponent } from './fc-year-month-input.component';


@NgModule({
  declarations: [
    FcYearMonthInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcYearMonthInputComponent
  ]
})
export class FcYearMonthInputModule {}
